module.exports = __webpack_public_path__ + "flag.21dfea10f2a29544bf3a00b0122b378c.svg";